module.exports = __webpack_public_path__ + "static/v1.a-thumb-63a465e4b98459128a1513a233265b10.jpg";